// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__27RUM","detailsBorder":"styles_detailsBorder__13uMS"};